import MassHiring from "./MassHiring";
export default MassHiring;
